var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.$i18n.locale === "pe"
      ? _c(
          "div",
          [
            _c("Message", {
              attrs: {
                message: "",
                icon: "coming_soon_cl.svg",
                "as-card": true,
              },
            }),
          ],
          1
        )
      : _vm._e(),
    _vm.$i18n.locale === "br"
      ? _c(
          "div",
          [
            _c("Message", {
              attrs: {
                message: "",
                icon: "coming_soon_br.svg",
                "as-card": true,
              },
            }),
          ],
          1
        )
      : _vm._e(),
    _vm.$i18n.locale === "cl"
      ? _c(
          "div",
          {
            attrs: { id: "trading-container", "data-cy": "trading-container" },
          },
          [
            _c("Tabs", {
              staticClass: "mt-6",
              attrs: {
                options: _vm.options,
                callback: _vm.getCompletedAppraisals,
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "0",
                    fn: function () {
                      return [_c("AppraisalProcess")]
                    },
                    proxy: true,
                  },
                  {
                    key: "1",
                    fn: function () {
                      return [
                        _c("AppraisalHistory", {
                          attrs: { "appraisal-list": _vm.appraisalList },
                          on: {
                            "filter-estado-actualizado": _vm.filter,
                            "filter-comprador-actualizado": _vm.filter,
                            "filter-tipo-venta-actualizado": _vm.filter,
                            "filter-usuario-actualizado": _vm.filter,
                            "filter-fecha-actualizado": _vm.filter,
                          },
                        }),
                      ]
                    },
                    proxy: true,
                  },
                ],
                null,
                false,
                2710286535
              ),
            }),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }